// parse a date in yyyy-mm-dd format (cross browser support) see https://stackoverflow.com/questions/24582638/why-does-my-time-ago-filter-work-in-chrome-and-not-safari-or-firefox
function parseDate(input) {
	var parts = input.split("-");
	var timeBits = parts[2].split(" ");
	var hms = timeBits[1].split(":");
	// new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
	return new Date(
		parts[0],
		parts[1] - 1,
		timeBits[0],
		hms[0],
		hms[1],
		hms[2]
	); // Note: months are 0-based
}

export default parseDate;
